import { Link } from "react-router";

import type { DramaSeries } from "~/api/drama";

/** For a black page. A separate component rather than a `dark` flag on the light card: the two
 *  differ in colour, type size and spacing, and a flag would put per-page branches in both. */
export function DramaCardDark({ series, genre }: { series: DramaSeries; genre?: string }) {
  return (
    <Link
      id={`cinema-catalogue-card-${series.id}`}
      to={`/cinema/detail?series=${encodeURIComponent(series.id)}`}
      className="flex flex-col gap-[4px]"
    >
      <div className="aspect-[2/3] w-full overflow-hidden rounded-[12px] border border-white/10 bg-neutral-800">
        {series.thumbnail && <img src={series.thumbnail} alt="" loading="lazy" className="size-full object-cover" />}
      </div>
      <div>
        <p className="line-clamp-2 text-[14px] leading-[20px] font-semibold text-neutral-50">{series.title}</p>
        {genre && <p className="text-[10px] leading-[14px] font-medium text-neutral-500">{genre}</p>}
      </div>
    </Link>
  );
}
